import React, { FC, useMemo } from "react";
import { Field } from "react-final-form";
import { getData } from "country-list";
import Autocomplete from "../../../../../components/Autocomplete";
import FieldsGroupLabel from "../common/FieldsGroupLabel";
import { ICourseComponentProps } from "../../../types";

const RestrictedCountries: FC<ICourseComponentProps> = ({
  fieldsGroupName,
}) => {
  const countries = useMemo(
    () =>
      getData().sort((a, b) =>
        a.name > b.name ? 1 : b.name > a.name ? -1 : 0,
      ),
    [],
  );

  return (
    <div>
      <FieldsGroupLabel label="Restrictions" className="fields-group-label" />
      <Field
        fullWidth
        type="text"
        label="Restricted Countries"
        options={countries}
        placeholder="Please Select"
        component={Autocomplete}
        multiple={true}
        disableCloseOnSelect={true}
        name={`${fieldsGroupName}.restrictedCountries`}
      />
    </div>
  );
};

export default React.memo(RestrictedCountries);
